import React from 'react';
import { Link } from 'react-router-dom';
import './BlogList.scss';

// grab every .js/.jsx file in BlogPostsContent
const req = require.context(
  '../BlogPostsContent',  // relative path from this file
  false,                  // do not recurse into subfolders
  /\.jsx?$/               // match .js and .jsx
);

// pull out the default export from each module
const blogPosts = req
  .keys()
  .map((key) => req(key).default)
  // ensure we only pick modules that have the shape we expect:
  .filter((post) => post && post.id && post.date)
  // sort by date descending:
  .sort((a, b) => new Date(b.date) - new Date(a.date));

const BlogList = () => {
  const [latestPost, ...otherPosts] = blogPosts;

  return (
    <div className="blog-list page-top-settings primary">
      <header>
        <h1>Laundry Detergent Sheets Manufacturer</h1>
        <h2 className="page-title">Blogs Page</h2>
      </header>

      {/* Latest */}
      {latestPost && (
        <div className="blog-latest">
          <img
            src={latestPost.imageUrl1}
            alt={latestPost.title}
            className="blog-image"
          />
          <div className="blog-details">
            <Link to={`/blogs/${latestPost.id}`} className="blog-title">
              {latestPost.title}
            </Link>
            <p className="blog-date">{latestPost.date}</p>
            <p className="mb-5">{latestPost.summary}</p>
            <Link to={`/blogs/${latestPost.id}`} className="blog-read-more">
              Read Article
            </Link>
          </div>
        </div>
      )}

      {/* Other posts */}
      <div className="blog-cards">
        {otherPosts.map((post) => (
          <div key={post.id} className="blog-card">
            <img
              src={post.imageUrl1}
              alt={post.title}
              className="blog-image"
            />
            <div className="blog-details">
              <Link to={`/blogs/${post.id}`} className="blog-title">
                {post.title}
              </Link>
              <p className="blog-date">{post.date}</p>
              <p className="blog-summary-text">{post.summary}</p>
              <Link to={`/blogs/${post.id}`} className="blog-read-more">
                Read Article
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
